import { useUser } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";

export const StudentRoute = ({ children }) => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/sign-in" />;
  }

  const isStudent = user.publicMetadata?.role === "student"; 

  return isStudent ? children : <Navigate to="/forbidden" replace />;
};
